export const backgroundColors = ['#648596', '#93544e', '#8e6fb6', '#5e8586', '#bfbb98', '#b6fed1', '#b0f6f8', '#fce4c0', '#d7d5fd', '#f7d5f0', '#dc668c'];
